import { DropdownMenuSub, DropdownMenuSubTrigger } from '@e2n/ui';
import { faNewspaper } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function NewsFeedMenuItemFallback() {
  const { t } = useTranslation();

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger className="flex items-center justify-between">
        <div className="w-full flex items-center gap-2">
          <FontAwesomeIcon icon={faNewspaper} />
          {t('general.navigation.profileDropdown.news')}
        </div>
      </DropdownMenuSubTrigger>
    </DropdownMenuSub>
  );
}
